import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {catchError, switchMap} from 'rxjs/operators';
import {from, of} from 'rxjs';
import {LoadError} from '@app/core/store/actions/error.actions';
import {
	ENotificationsActions,
	GetLatestNotifications,
	GetLatestNotificationsSuccess,
	GetNotificationNumbers,
	GetNotificationNumbersSuccess,
	MarkAllNotificationsAsRead,
	MarkAllNotificationsAsReadSuccess,
	MarkConversationAsRead,
} from '@app/core/store/actions/notifications.actions';
import {NotificationService} from '@app/core/services/api/notification.service';

@Injectable()
export class NotificationsEffects {

	@Effect()
	public onGetLatestNotifications = this.actions$.pipe(
		ofType<GetLatestNotifications>(ENotificationsActions.GetLatestNotifications),
		switchMap((action: GetLatestNotifications) => from(this.notificationService.getLatestNotifications().pipe(
			switchMap((notifications) => [
				new GetLatestNotificationsSuccess(notifications),
			]),
			catchError(error => of(new LoadError(error, action))),
		)))
	);

	@Effect()
	public onGetNotificationNumbers = this.actions$.pipe(
		ofType<GetNotificationNumbers>(ENotificationsActions.GetNotificationNumbers),
		switchMap((action: GetNotificationNumbers) => from(this.notificationService.getNotificationNumbers().pipe(
			switchMap((notificationNumbers) => [
				new GetNotificationNumbersSuccess(notificationNumbers),
			]),
		)))
	);

	@Effect()
	public onMarkAllNotificationsAsRead = this.actions$.pipe(
		ofType<MarkAllNotificationsAsRead>(ENotificationsActions.MarkAllNotificationsAsRead),
		switchMap((action: MarkAllNotificationsAsRead) => from(this.notificationService.markAllNotificationsAsRead().pipe(
			switchMap((notifications) => [
				new MarkAllNotificationsAsReadSuccess(),
			]),
			catchError(error => of(new LoadError(error, action))),
		)))
	);

	@Effect()
	public onMarkConversationAsRead = this.actions$.pipe(
		ofType<MarkConversationAsRead>(ENotificationsActions.MarkConversationAsRead),
		switchMap((action: MarkConversationAsRead) => from(this.notificationService.markConversationAsRead(action.conversationId).pipe(
			switchMap(() => []),
			catchError(error => of(new LoadError(error, action))),
		)))
	);

	constructor(
		private actions$: Actions,
		private notificationService: NotificationService,
	) {
	}
}
